import React from "react";
import { useNavigate } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import "./AuthLeftSection.css";

export const handleDownloadGoogleAppClick = () => {
    window.open("https://play.google.com/store/apps/details?id=com.amalgamate", "_blank");
};

export const handleDownloadAppleAppClick = () => {
    window.open("https://apps.apple.com/in/app/amalgamate/id6744918457", "_blank");
};

const AuthLeftSection = () => {
    const navigate = useNavigate();

    return (
        <div className="landingLeftSection">
            <div className="landingLeftSectionContainer">
                <div className="authLeftTopBar">
                    <button 
                        type="button"
                        className="authBackHubBtn" 
                        onClick={() => navigate('/')}
                        title="Return to Amalgamate Home"
                    >
                        ← Back to Hub
                    </button>
                    <div 
                        className="amalgamateLogoContainer" 
                        onClick={() => navigate('/')} 
                        style={{ cursor: 'pointer' }}
                        title="Return to Amalgamate Home"
                    >
                        <img
                            className="authLeftSectionLogo webAmalgamateLogo amalgamateLogo"
                            src="/Assets/LandingPage/AmalgamateLogo.svg"
                            alt="Amalgamate Logo"
                        />
                    </div>
                </div>
                <div className="leftSectionContentContainer">
                    <div className="leftSectionContent">
                        <DoneIcon sx={{ height: "22px", width: "22px", color: "#48D1CC", marginTop: "4px" }} />
                        <div className="textContainer">
                            <span className="contentHeading">Amalgamate</span>
                            <span className="contentTexts">
                                Connect with like-minded groups
                            </span>
                            <span className="contentTexts">
                                Participate in verified voting & polls
                            </span>
                        </div>
                    </div>
                    <div className="leftSectionContent">
                        <DoneIcon sx={{ height: "22px", width: "22px", color: "#48D1CC", marginTop: "4px" }} />
                        <div className="textContainer">
                            <span className="contentHeading">Educate</span>
                            <span className="contentTexts">
                                Earn certifications
                            </span>
                            <span className="contentTexts">
                                Join community discussions & insights
                            </span>
                        </div>
                    </div>
                    <div className="leftSectionContent">
                        <DoneIcon sx={{ height: "22px", width: "22px", color: "#48D1CC", marginTop: "4px" }} />
                        <div className="textContainer">
                            <span className="contentHeading">Facilitate</span>
                            <span className="contentTexts">
                                List services & host events
                            </span>
                            <span className="contentTexts">
                                Avail offerings & monetize your skills
                            </span>
                        </div>
                    </div>
                </div>
                <div className="lowerSection">
                    <div className="webGetTheAppContainer getTheAppContainer">
                        <div className="fadingLine1"></div>
                        <span className="webGetTheAppText getTheAppText">Get The App</span>
                        <div className="fadingLine2"></div>
                    </div>
                    <div className="downloadAppCards">
                        <div className="downloadAppCardContainer">
                            <div className="webDownloadAppCard downloadAppCard" onClick={handleDownloadGoogleAppClick}>
                                <img
                                    src="/Assets/LandingPage/playStoreIcon.svg"
                                    alt="Google Play"
                                    className="webDownloadAppCardIcon downloadAppCardIcon"
                                />
                                <div className="downloadAppCardTextContainer">
                                    <span className="webDownloadAppCardText1 downloadAppCardText1">Get it on</span>
                                    <span className="webDownloadAppCardText2 downloadAppCardText2">
                                        Google Play
                                    </span>
                                </div>
                            </div>
                            <div className="webDownloadAppCard downloadAppCard" onClick={handleDownloadAppleAppClick}>
                                <img
                                    src="/Assets/LandingPage/appStoreIcon.svg"
                                    alt="App Store"
                                    className="webDownloadAppCardIcon2 downloadAppCardIcon2"
                                />
                                <div className="downloadAppCardTextContainer">
                                    <span className="webDownloadAppCardText1 downloadAppCardText1">Get it on</span>
                                    <span className="webDownloadAppCardText2 downloadAppCardText2">
                                        App Store
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthLeftSection;
